// extracted by mini-css-extract-plugin
module.exports = {"dark-form-control-select":"resolutions_dark-form-control-select__PJBJm"};